import { computed } from "vue";
import { ProcessingState } from "@/modules/internal_api/image";
import { useEditorStore } from "@/stores/editor_store";

export const useDeleteConfirmation = () => {
  const store = useEditorStore();

  const requiresDeleteConfirmation = computed(() => {
    const image = store.selectedImage;
    if (!image) return false;

    const imageHdResult = image.hdResult;
    const isHdResultPresent = imageHdResult !== undefined;
    const isHdResultProcessed =
      imageHdResult?.state === ProcessingState.Processing || imageHdResult?.state === ProcessingState.Finished;

    // check if there are any magic backgrounds present
    const isMagicBackgroundProcessed = image.magicBackgroundResults?.size > 0;

    // we required delete confirmation for any image that is processed and hd is downloaded (or credit is spent processing it)
    // or has magic backgrounds processed/processing
    return (isHdResultPresent && isHdResultProcessed) || isMagicBackgroundProcessed;
  });

  return {
    requiresDeleteConfirmation,
  };
};
